import loadProducts from '../lib/collection';
import { changeItem, addToCart } from '../lib/cart';
import { lockScroll, unlockScroll } from '../utils/util-functions';

export default (node) => {
  /**
   * Data + elements
   */
  const cartDrawerEl = node;
  const cartContentWrapper = node.querySelector('[data-cart-content-wrapper]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const closeDrawerButton = node.querySelector('[data-close-drawer]');
  const cartContentLoading = node.querySelector('[data-cart-content-loading]');
  const cartListener = window;
  const cartError = node.querySelector('[data-cart-error]');

  const moneyFormat = cartDrawerEl
    .getAttribute('data-money-format')
    .replace('amount_with_dot_separator', 'amount');

  /**
   * Functions
   */

  const initUpsellSwiper = (node) => {
    const swiperContainer = node.querySelector('.upsell-swiper');
    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      loop: false,
      breakpoints: {
        640: { slidesPerView: 1.2 },
      },
    });
  };

  const initUpsellAddToCart = (node) => {
    const upsellButtons = node.querySelectorAll('.cart-upsell-add');
    upsellButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        try {
          await addToCart([{ id: Number(variantId), quantity: 1 }]);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (err) {
          console.error('Upsell Add to Cart error:', err);
          document.dispatchEvent(
            new CustomEvent('cart:error', {
              detail: 'There was a problem adding the item to your cart.',
            })
          );
        }
      });
    });
  };

  /**
   * Update Quantity Cart Info
   * @param {*} e
   */
  const updateQuantityCartInfo = async (lineItem, newQuantity) => {
    cartContentLoading.classList.remove('hidden');
    cartContentWrapper.classList.add('overflow-y-hidden');

    const updatedCart = await changeItem({
      key: lineItem,
      quantity: newQuantity,
    });

    // Re-initialize everything
    initUpsellSwiper(cartDrawerEl);
    initUpsellAddToCart(cartDrawerEl);
    attachEventListener(); // if needed for +/- buttons

    cartContentLoading.classList.add('hidden');
    cartContentWrapper.classList.remove('overflow-y-hidden');
  };

  /**
   * Open cart after adding item
   */
  const openCart = async (data) => {
    // check if the current page is the main cart page to dont open the cart drawer
    if (window.location.pathname === '/cart') return;

    lockScroll();

    cartOverlay.classList.remove('hidden');
    cartDrawerEl.classList.add('!translate-x-0');
    cartListener.addEventListener('keydown', handleEscapeKey);
    setRealColorNames();

    // Re-initialize both!
    initUpsellSwiper(cartDrawerEl);
    initUpsellAddToCart(cartDrawerEl);

    document.dispatchEvent(new CustomEvent('upsell-products:loadlistener'));
  };

  const fetchProductWithHandle = async (url) => {
    const response = await loadProducts(url);

    // update the product slider
    const newMainProduct = response.querySelector('.product-main-section');
    if (newMainProduct.querySelector('[data-product-main-wrapper]')) {
      newMainProduct
        .querySelector('[data-product-main-wrapper]')
        .classList.remove('md:!px-4');
      newMainProduct
        .querySelector('[data-product-main-wrapper]')
        .classList.remove('md_lg:!px-12');
    }
    if (newMainProduct.querySelector('.data-slider-mobile-wrapper')) {
      // remove zoom effect
      const allImagesMobile = newMainProduct.querySelectorAll(
        '.data-slider-mobile-wrapper > a'
      );
      allImagesMobile.forEach((image) => {
        image.setAttribute('href', '#');
      });
    }

    if (newMainProduct.querySelector('[data-slider-main-wrapper]')) {
      newMainProduct
        .querySelector('[data-slider-main-wrapper]')
        .classList.add('h-screen');
      newMainProduct
        .querySelector('[data-slider-main-wrapper]')
        .classList.remove('data-slider-main-wrapper');
      newMainProduct
        .querySelector('[data-slider-main-wrapper]')
        .classList.add('[&>a]:!h-[800px]');

      // remove zoom effect
      const allImages = newMainProduct.querySelectorAll(
        '[data-product-handle-media]'
      );
      allImages.forEach((image) => {
        image.classList.remove('cursor-zoom-in');
        image.classList.add('pointer-events-none');
      });
    }
    if (newMainProduct.querySelector('[data-product-description]')) {
      newMainProduct
        .querySelector('[data-product-description]')
        .classList.add('hidden');
    }
    if (newMainProduct.querySelector('[data-product-main-images]')) {
      newMainProduct
        .querySelector('[data-product-main-images]')
        .classList.add('overflow-scroll');
      newMainProduct
        .querySelector('[data-product-main-images]')
        .classList.add('h-screen');

      // get all images and add height
      const allImages = newMainProduct.querySelectorAll(
        '[data-product-main-images] > div > a'
      );
      if (allImages) {
        allImages.forEach((image) => {
          image.classList.add('!h-[800px]');
        });
      }
    }
    if (newMainProduct.querySelector('[data-button-read-more]')) {
      newMainProduct
        .querySelector('[data-button-read-more]')
        .classList.add('hidden');
    }
    if (newMainProduct.querySelector('[data-product-view-full-details]')) {
      newMainProduct
        .querySelector('[data-product-view-full-details]')
        .classList.remove('hidden');
    }
    if (newMainProduct.querySelector('[data-product-blocks]')) {
      newMainProduct.querySelector('[data-product-blocks]').remove();
    }
    if (newMainProduct.querySelector('[data-product-accordion]')) {
      newMainProduct.querySelector('[data-product-accordion]').remove();
    }
    if (newMainProduct.querySelector('[data-component="buttonAddToCart"]')) {
      newMainProduct
        .querySelector('[data-component="buttonAddToCart"]')
        .classList.remove('border-solid');
      newMainProduct
        .querySelector('[data-component="buttonAddToCart"]')
        .classList.add('border-none');
    }
    if (newMainProduct.querySelector('[data-product-size-guide-trisfit]')) {
      newMainProduct
        .querySelector('[data-product-size-guide-trisfit]')
        .remove();
    }
    if (newMainProduct.querySelector('[data-component="productVariant"]')) {
      newMainProduct
        .querySelector('[data-component="productVariant"]')
        .setAttribute('data-is-slider-product', 'true');
    }
    if (newMainProduct.querySelector('[data-component="modelAlsoWearing"]')) {
      newMainProduct
        .querySelector('[data-component="modelAlsoWearing"]')
        .remove();
    }
    const currentMainProduct = document.querySelector(
      '[data-slider-product-content]'
    );
    currentMainProduct.innerHTML = newMainProduct.innerHTML;

    checkEmptyProductCard();
  };

  // check if the product card is empty or not, if empty, hide the wrapper
  const checkEmptyProductCard = () => {
    const productCards = document.querySelectorAll(
      '[data-model-also-wearing-content] > [data-product-wrapper]'
    );
    if (productCards) {
      productCards.forEach((card) => {
        if (card.innerHTML.length < 100) {
          card.classList.add('hidden');
        }
      });
    }
  };

  const setRealColorNames = () => {
    // get the color swatches full data
    let storedColorSwatchesFullData = sessionStorage.getItem(
      'colorSwatchesFullData'
    );
    storedColorSwatchesFullData = JSON.parse(storedColorSwatchesFullData);
    if (!storedColorSwatchesFullData) {
      storedColorSwatchesFullData = [];
    }

    const allCartItems = document.querySelectorAll('[data-item-color]');
    allCartItems.forEach((colorCode) => {
      const dataColor = colorCode.getAttribute('data-item-color');
      if (dataColor) {
        // find dataColor in the colorSwatchesFullData
        const color = storedColorSwatchesFullData.find((color) => {
          return color.code === dataColor;
        });

        if (color) {
          colorCode.innerHTML =
            window.Shopify.locale === 'fr' ? color.french : color.name;
        }
      }
    });
  };

  /**
   * handle Escape key to close cart drawer
   */
  const handleEscapeKey = (e) => {
    if (e.key === 'Escape') {
      closeCart();
    }
  };

  /**
   * close cart drawer
   */
  const closeCart = () => {
    cartDrawerEl.classList.remove('!translate-x-0');

    unlockScroll();

    // remove event listener for escape key
    cartListener.removeEventListener('keydown', handleEscapeKey);
    cartOverlay.classList.add('hidden');
  };

  /**
   * Reattach eventlistener
   */
  const attachEventListener = () => {
    const allItems = node.querySelectorAll('[data-cart-item]');
    allItems.forEach((item) => {
      const itemIncrease = item.querySelector('[data-cart-quantity-increase]');
      if (itemIncrease) {
        itemIncrease.addEventListener('click', () => {
          updateQuantityCartInfo(
            item.dataset.lineItemKey,
            Number(item.dataset.lineCurrentQuantity) + 1
          );
        });
      }
      const itemDecrease = item.querySelector('[data-cart-quantity-decrease]');
      if (itemDecrease) {
        itemDecrease.addEventListener('click', () => {
          updateQuantityCartInfo(
            item.dataset.lineItemKey,
            Number(item.dataset.lineCurrentQuantity) - 1
          );
        });
      }

      const itemRemove = item.querySelector('[data-cart-remove-item]');
      if (itemRemove) {
        itemRemove.addEventListener('click', () => {
          updateQuantityCartInfo(item.dataset.lineItemKey, 0);
        });
      }
    });

    document.addEventListener('cart-note:saved', changeNoteText);

    const addNote = document.querySelector('[data-add-note-trigger]');

    addNote.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('add-note:open'));
    });
  };

  const showError = (message) => {
    cartContentLoading.classList.add('hidden');
    cartContentWrapper.classList.remove('overflow-y-hidden');
    cartError.textContent = message.detail;
    cartError.classList.remove('hidden');
    // close error message after 5 seconds
    setTimeout(() => {
      cartError.classList.add('hidden');
      cartError.textContent = '';
    }, 5000);
  };

  const changeNoteText = (e) => {
    const editNoteText = document.querySelector('[data-edit-note-text]');
    const addNoteText = document.querySelector('[data-add-note-text]');
    const addNote = document.querySelector('[data-add-note-trigger]');

    if (editNoteText && addNoteText) {
      if (e.detail.note.length > 0) {
        addNote.innerText = editNoteText.getAttribute('data-edit-note-text');
      } else {
        addNote.innerText = addNoteText.getAttribute('data-add-note-text');
      }
    }
  };

  /**
   * Init
   */
  const init = () => {
    attachEventListener();

    closeDrawerButton.addEventListener('click', closeCart);

    // add event listener for cart:reattach-listener
    document.addEventListener('cart:attachListener', attachEventListener);

    // add event listener for cart:updated
    document.addEventListener('cart:updated', openCart);

    document.addEventListener('cart:error', showError);

    // add event listener for cart:open
    document.addEventListener('cart:open', openCart);

    document.addEventListener('cart:close', closeCart);

    // add event listener for body to close drawer when click outside cart or press escape key
    cartOverlay.addEventListener('click', (e) => {
      // skip when cart button on the header is press
      closeCart();
    });

    document.addEventListener(
      'cart-drawer:check-empty-product-card',
      checkEmptyProductCard
    );

    initUpsellSwiper(node);
    initUpsellAddToCart(node);
  };

  init();
};
